var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"h-full"},[_c('div',{staticClass:"rounded bg-white"},[_c('div',{staticClass:"mb-6"},[_c('eCommSitesOwned')],1),_c('div',{staticClass:"mt-8"},[_c('eCommTextOnly')],1),_c('div',{staticClass:"mt-8"},[_c('eCommSitesBarChart')],1),_c('div',{staticClass:"mt-8"},[_c('ECommSitesTextOnly')],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }